import { render, staticRenderFns } from "./BimDatabankCategory.vue.html?vue&type=template&id=e563cb62&scoped=true&lang=html&external"
import script from "./BimDatabankCategory.vue.js?vue&type=script&lang=js&external"
export * from "./BimDatabankCategory.vue.js?vue&type=script&lang=js&external"
import style0 from "./BimDatabankCategory.vue.scss?vue&type=style&index=0&id=e563cb62&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e563cb62",
  null
  
)

export default component.exports